import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient } from '@angular/common/http';
import { User } from '../User';
import { AlertService } from '../alert.service';
import { ModalDirective } from 'angular-bootstrap-md';
import { EditEmailDialogComponent } from '../edit-email-dialog/edit-email-dialog.component';
import { EditMobileDialogComponent } from '../edit-mobile-dialog/edit-mobile-dialog.component';
import { EditDldialogComponent } from '../edit-dldialog/edit-dldialog.component';
import { EditAddressDialogComponent } from '../edit-address-dialog/edit-address-dialog.component';
import { OpenOtpdialogComponent } from '../open-otpdialog/open-otpdialog.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
// export interface User{
//   email:string;
// }

  
@Component({
  selector: 'app-userdetails',
  templateUrl: './userdetails.component.html',
  styleUrls: ['./userdetails.component.scss']
})
export class UserdetailsComponent implements OnInit {
  @ViewChild('mobileVerifyModal') mobileVerifyModal: ModalDirective;
  @ViewChild('mobileEditModal') mobileEditModal: ModalDirective;
  @ViewChild('OTPModal') OTPModal: ModalDirective;

 email:string;
 private user: User = new User();
 emailAdd: String = "";
 addresss: String = "";
 mobileNumber: String = "";
 public showMsg;
 mobileverifyMsg:string =""; //shows msg mobile verified or not

 


 custData: Observable<any>;
 city = 1;
 state = 1;
 
 private debugData: Boolean = true;  // to show and hide the data in console log
 otpErrorMsg: string = ""; // to display the error msg on otp popup
 
 
 constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
 private httpClient: HttpClient, private alertService: AlertService, public dialog: MatDialog) {

}

openEmailEditDialog() {
  const dialogRef = this.dialog.open(EditEmailDialogComponent, {
       //data: {email: this.email}
  }); 

  dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog was closed');
    this.initCustData();
    //this.email = this.user.email;
    //console.log("updated" +this.email)
  });
}

openMobileEditDialog() {
  const mob_dialogRef = this.dialog.open(EditMobileDialogComponent, {
       //data: {email: this.email}
  });

  mob_dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog hello closed');
    this.initCustData();
    //this.openOTPDialog();
    this.OTPModal.show();
    //this.email = this.user.email;
    //console.log("updated" +this.email)
  });
}

openDLEditDialog() {
  const dl_dialogRef = this.dialog.open(EditDldialogComponent, {
       //data: {email: this.email}
  });

  dl_dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog was closed');
    this.initCustData();
    //this.email = this.user.email;
    console.log("updated" +this.user.mobile)
  });
}

openAddressEditDialog() {
  const addr_dialogRef = this.dialog.open(EditAddressDialogComponent, {
       //data: {email: this.email}
  });

  addr_dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog was closed');
    this.initCustData();
    //this.email = this.user.email;
    //console.log("updated" +this.email)
  });
}
// data1;
// openOTPDialog() {
//   const otp_dialogRef = this.dialog.open(OpenOtpdialogComponent, {
//        data: {mobile: this.user.mobile}
//   });

//   otp_dialogRef.afterClosed().subscribe(result => {
//     console.log('The dialog was closed');
//     this.data1=this.user;
//     this.initCustData();
//     console.log(this.user.mobile);
//     console.log(this.data1.mobile)
//     //this.email = this.user.email;
//     //console.log("updated" +this.email)
//   });
// }
 ngOnInit() {
 this.initCustData();
}




 initCustData() {
 if (this.apiService.checkUserLoggedIn() == true) {
 let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
 this.httpClient.get(urrr)
.subscribe(
 data => this.intilizeComponent(data),
 error => this.showError(error)
);

} else {
 console.log("User Not Logged In. Please login!")
}

}
mobile:number;
 intilizeComponent(data) {
 this.user = data;
//  this.mobile=this.user.mobile;
//  console.log("updated mob no." +this.mobile);
 this.getReferralPoints();
 if(this.user.mobileVerified == 0)
 {
  this.mobileverifyMsg="mobile not verified";
 }
 else{
  this.mobileverifyMsg="mobile verified";
 }
// this.mobileNumberVerified();
}

 showError(msg) {
 console.log("Error Found in server");
}



 isEmptyObject(obj) {
 return (obj && (Object.keys(obj).length === 0));
}


mobileNumberVerified()
{
  if (this.user.mobileVerified == 0)
  {
    console.log("please verify your numbersss")
    //this.mobileverifyMsg="mobile not verified";
    this.sendOtpN(this.user.mobile, this.user.id);
    this.OTPModal.show();
    //this.dialog.open(EditMobileDialogComponent);
    //this.openOTPDialog();
    
  }
  else{
    console.log("update your number")
    //this.mobileverifyMsg="mobile verified";
   // this.mobileEditModal.show();
   this.openMobileEditDialog();
  }
}

updateDLnumber(userDLnumber) {
  if (this.apiService.checkUserLoggedIn() == true) {
    let addUpdateURL = this.apiService.cutomerDetails + this.user.id;
    let postDataDL = { 'DLnumber': userDLnumber }
    this.httpClient.post(addUpdateURL, postDataDL)
      .subscribe(
        (dl_detail: any) => {
          this.user = dl_detail;
        }
      )
  } else {
    console.log("User not logged in .");
  }
} 

// <!-- start of OTP verify function  -->
verifyOtpN(otpToVerify) {
  let postData = { 'mobile': this.user.mobile, 'otp': otpToVerify }
  if (this.debugData) {
    console.log("very otp json data is ")
    console.log(postData);
  }
  this.httpClient.post(this.apiService.verifyOTP_URL, postData)
    .subscribe(
      (detail: any) => {
        if (this.debugData) {
          console.log("very otp function API Data ")
          console.log(detail);
        }
        if (detail.status == true) {
          if (this.debugData) {
            console.log("Success OTP Verified")
          }
          this.user = detail.obj;
          this.otpErrorMsg = "OTP Verified";
          this.refresh();
        } else {
          if (this.debugData) {
            console.log(" OTP not Verified")
          }
          this.otpErrorMsg = "Incorrect OTP";
        }
      }
    )
}
// <!-- end of OTP verify function  -->

// <!-- Start of OTP send function  -->
sendOtpN(mobileNumber, custId) {
  let postData = { 'mobile': mobileNumber, 'id': custId };
  this.httpClient.post(this.apiService.sendOtpURL, postData)
    .subscribe(
      (detail: any) => {
        if (this.debugData) {
          console.log("Send OTP Api data");
          console.log(detail);
        }
        if (detail.status == true) {
          return true;
        } else {
          return false;
        }
      }
    )
}
// <!-- end of OTP send function  -->

// <!-- start of OTP Resend function  -->
resendOtpNow() {
  if (this.apiService.checkUserLoggedIn() == true) {
    let postData = { 'mobile': this.user.mobile };
    this.httpClient.post(this.apiService.resendURL, postData)
      .subscribe(
        (detail: any) => {
          if (this.debugData) {
            console.log("resend otp function API data");
            console.log(detail);
          }
          if (detail.status == true) {
            this.otpErrorMsg = "OTP sent"
          } else {
            this.otpErrorMsg = "OTP sending fail"
          }
        },
        (err) => {
          this.otpErrorMsg = "Some error occured. Please try again."
        });
  } else {
    //this.warn("Please Login");
  }
}
// <!-- end of OTP Resend function  -->

refresh(): void {
  window.location.reload();
}

//  updateMobileNumber(mobileNumber) {
//  if (this.apiService.checkUserLoggedIn() == true) {
//  let postData = { 'mobile': mobileNumber, 'id': this.user.id, 'type': 'mobile', 'oldMobile': this.user.mobile }
//  this.httpClient.post(this.apiService.profileUpdateURL, postData)
// .subscribe(
// (detail: any) => {

//  if (detail.status == true) {
//  console.log("otp sent to the number");
//  console.log("NOT");
//  this.initCustData();
// } else {
//  console.log("PLease retry some error occured");
// }
// },
//  error => this.Error1("this email address is already exist")
// )
// } else { console.log("Please login"); }
// }

 Error1(msg) {
 this.alertService.warn("");
}

 editEmail: string
 updateEmailAddress(emailAdd) {
 if (emailAdd != null) {
 if (this.apiService.checkUserLoggedIn() == true) {
 let postData = { 'email': emailAdd, 'id': this.user.id, 'type': 'email', 'oldEmail': this.user.email }
 this.httpClient.post(this.apiService.profileUpdateURL, postData)
.subscribe(
(detail: any) => {
 this.user = detail;
 this.initCustData()
},
 error => this.Error1(error)
)
} else {
 console.log("Please login");
}
}
 else {
 console.log("please add email address");
}
}


 updateUserAddress(addressUsr, pincodeUsr , cityUsr, stateUsr) {
 if (this.apiService.checkUserLoggedIn() == true) {
 let addUpdateURL = this.apiService.cutomerDetails + this.user.id;
 let postData = { 'address': addressUsr, 'pinCode': pincodeUsr, 'city': cityUsr, 'state': stateUsr }
 this.httpClient.post(addUpdateURL, postData)
.subscribe(
(detail: any) => {
 this.user = detail;
}
)
} else {
 console.log("User not logged in .");
}

}

getrefDetail:string;
private points="";
getReferralPoints()
  {
    let getRefpoint = {"id":this.user.id}
     this.httpClient.post(this.apiService.referralURL, getRefpoint)
     .subscribe(
       (refdetail:any) =>{
         //console.log("data4 is" + refdetail)
         this.getrefDetail = refdetail;
         this.points=refdetail.points;
       }
     )
  }
}





// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/userdetails/userdetails.component.ts